import { easyPost } from './request';

export const getTupleList = easyPost('/trade/futures/getInstruments');

export const placeOrder = easyPost('/trade/futures/orders');

export const cancelAll = easyPost('/trade/futures/cancelOrders');

export const getLeverage = easyPost('/trade/futures/getLeverage');

export const setLeverage = easyPost('/trade/futures/setLeverage');
